import { useFormik } from "formik";
import { ActionIcon, Button, Modal, Text } from "rizzui";
import CanvasEditor from "../../../components/drawCanvas/CanvasEditor";
import { IoClose } from "react-icons/io5";
import { useEffect, useRef } from "react";
import { IssueService } from "../../../services/issue/issueService";
import { toast } from "sonner";

interface DrawCanvasFormModalProps {
    isOpen: boolean;
    onClose: () => void;
    refetch: () => void;
    issue: any;
}

const DrawCanvasFormModal: React.FC<DrawCanvasFormModalProps> = ({ isOpen, onClose, refetch, issue }) => {

    // HOOKS

    const issueService = new IssueService();

    // REFS

    const canvasEditorRef = useRef(null);

    // DATA FETCHING

    // FUNCTIONS

    //----------------------------------------------------------------------------------------------------------------------------
    /**
     * @ES MANEJA EL ENVIO DEL FORMULARIO
     * @EN HANDLES THE FORM SUBMISSION
     * @param values
     */
    //----------------------------------------------------------------------------------------------------------------------------
    const handleSubmit = async (values: { id: string }) => {
        //@ts-ignore
        const base64 = canvasEditorRef.current?.getImageBase64() || '';

        if (!base64) {
            console.error('No image data found');
            return;
        }

        const response = await (await issueService.updateIssueLocationCorpse(values.id, base64)).getResponseData();

        if (response.success) {
            toast.success('Localización guardada correctamente');
            refetch();
            onClose();
        } else {
            toast.error('Error al guardar la localización');
            refetch();
            onClose();
        }
      };
    //----------------------------------------------------------------------------------------------------------------------------

    // FORMIK

    const formik = useFormik({
        initialValues: {
            id: ''
        },
        onSubmit: async (values) => {
            handleSubmit(values);
        },
    });

    useEffect(() => {   
        if (isOpen && issue) {
            formik.setFieldValue('id', issue);
        } else {
            formik.resetForm();
        }
    }, [isOpen , issue]);

    // RENDER

    return (
         <Modal
            isOpen={isOpen}
            onClose={() => {
                formik.resetForm();
                onClose();
            }}
            size='sm'
            overlayClassName='backdrop-blur'
            containerClassName='!max-w-xl !shadow-xl'
            className='z-[9999] [&_.pointer-events-none]:overflow-visible'
        >
            <div className='m-auto px-7 pt-6 pb-4'>
                <div className='mb-7 flex items-center justify-between'>
                    <Text className="text-xl">Localizar Cadaver respecto al aerogenerador</Text>
                    <ActionIcon size='sm' variant='text' onClick={() => {
                        formik.resetForm();
                        onClose();
                    }}>
                        <IoClose className='h-auto w-6' strokeWidth={1.8} />
                    </ActionIcon>
                </div>

                <CanvasEditor ref={canvasEditorRef} imageUrl={'/media/imagen-canvas.png'}/>
            </div>
             <div className='flex justify-center p-7'>
                <Button
                    disabled={formik.isSubmitting}
                    onClick={() => formik.handleSubmit()}
                    color='primary'
                >
                    {formik.isSubmitting ? 'Loading...' : 'Guardar'}
                </Button>
            </div>
        </Modal>
    );

}

export default DrawCanvasFormModal;